// Library Methods
import { useNavigate } from "react-router-dom";

// Components
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Popover from "@mui/material/Popover";
import { useTheme } from "@mui/material/styles";

// Styles
import {
  getSurfaceTokens,
  getPopoverPaperSx,
} from "src/styles/mui/muiStylesHelper";

type ExamCardMenuType = {
  examMenu: HTMLButtonElement | null;
  examMenuClose: () => void;
  examMenuButtons: Array<{
    icon: JSX.Element;
    tooltipText: string;
    text: string;
    onClick: () => void;
    display: boolean;
    disabled: boolean;
    href: string | undefined;
  }>;
};

const ExamCardMenu = ({
  examMenu,
  examMenuClose,
  examMenuButtons,
}: ExamCardMenuType) => {
  const navigate = useNavigate();
  const theme = useTheme();
  const { onSurface } = getSurfaceTokens(theme);

  return (
    <Popover
      sx={{ mt: 0 }}
      open={Boolean(examMenu)}
      anchorEl={examMenu}
      onClose={examMenuClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      PaperProps={{
        style: {
          width: "200px",
          padding: "8px",
          borderRadius: "4px",
          ...getPopoverPaperSx(theme),
        },
      }}
    >
      <Box display="flex" gap="4px" flexDirection="column" width="100%">
        {examMenuButtons.map((examMenuButton) => (
          <Button
            key={examMenuButton.text}
            disabled={examMenuButton.disabled}
            onClick={() => {
              // close the menu when an option is clicked
              if (examMenuButton.href) navigate(examMenuButton.href);
              else examMenuButton.onClick();
              examMenuClose();
            }}
            startIcon={examMenuButton.icon}
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              color: onSurface,
              textTransform: "capitalize",
              fontSize: "16px",
              "&:hover": {
                backgroundColor: "#5B6D7A20",
              },
            }}
          >
            {examMenuButton.text}
          </Button>
        ))}
      </Box>
    </Popover>
  );
};

export default ExamCardMenu;
